import { styled } from '@mui/material';
import { MaterialDesignContent } from 'notistack';

/**
 * Every app snackbar, kept compact: notistack's default runs full width with
 * 16px text on narrow screens and drops the close button onto a line of its
 * own, so a one-sentence error filled a third of the screen.
 */
const CompactSnackbar = styled(MaterialDesignContent)(({ theme }) => ({
  '&.notistack-MuiContent': {
    maxWidth: 420,
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
    padding: '4px 6px 4px 14px',
    borderRadius: 10,
    fontSize: '14px',
    lineHeight: 1.45,
    boxShadow: theme.shadows[4],
  },
  '& #notistack-snackbar': {
    padding: '8px 0',
    gap: 8,
    '& svg': { fontSize: 18, flex: 'none' },
  },
  // The close button, top-right beside the text rather than under it.
  '& #notistack-snackbar + div': {
    flex: 'none',
    marginRight: 0,
    paddingLeft: 8,
  },
}));

export default CompactSnackbar;
